'use client';

import { Box } from '@coolblue-development/freddy';
import showCollectionTrigger from '@coolblue-development/ga4-events/triggers/ProductCollection/showCollectionTrigger';
import { TrackImmediate } from '@coolblue-development/next-analytics/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { matchPropertyValues, shouldShowCollection } from '@utils/collectionUtils';

import { type CollectionProps, CollectionType } from './Collection.types';
import { DropdownCollectionDesktop } from './DropdownCollection/DropdownCollection.Desktop';
import { PropertyCollection } from './PropertyCollection';

export const DesktopCollection = ({ collection, mainImageId, product }: CollectionProps) => {
  const { isDesktop } = useBreakpoints();
  const mappedCollection = matchPropertyValues(collection, product.id);
  const { isInternalUser } = useRequestContext();

  if (!shouldShowCollection(mappedCollection)) return <></>;

  const collectionProductIds = mappedCollection.discriminants[0].values
    .flatMap(value => value.products)
    .filter(product => product?.id)
    .map(product => product?.id);

  return (
    <>
      {isDesktop && (
        <TrackImmediate
          trigger={showCollectionTrigger({
            sub_feature:
              mappedCollection.type === CollectionType.DROPDOWN
                ? 'drop_down_selector'
                : 'multi_discriminant_selector',
            item_ids: collectionProductIds.toString()
          })}
        />
      )}

      {collection.type === CollectionType.PROPERTY && (
        <Box hideUntil='md' {...(isInternalUser && { 'data-cy': 'collection-property' })}>
          <PropertyCollection
            collection={mappedCollection}
            mainImageId={mainImageId}
            product={product}
          />
        </Box>
      )}
      {collection.type === CollectionType.DROPDOWN && (
        <Box hideUntil='md' {...(isInternalUser && { 'data-cy': 'collection-dropdown' })}>
          <DropdownCollectionDesktop
            product={product}
            collection={mappedCollection}
            productType={product.productType}
          />
        </Box>
      )}
    </>
  );
};
